import React, { useState, useEffect } from 'react';
import DatePicker from 'react-bootstrap-date-picker';
import moment from 'moment';
import Api from './Config';
import AverageResponseCards from './AverageResponseCards';
import AverageResponseChart from './AverageResponseChart';
import AverageResponseCsv from './AverageResponseCsv';

const labelStyle = {
  color: '#777',
  fontSize: '14px',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  marginBottom: '30px',
};

const dateStyle = {
  color: '#777',
  fontSize: '14px',
};

const getDaysDiff = (day) => {
  const tm = new Date();
  tm.setDate(tm.getDate() + day);
  return moment(tm).format('YYYY-MM-DD');
};

const getFirstDateOfMonth = () => {
  const tm = new Date();
  const firstDay = new Date(tm.getFullYear(), tm.getMonth(), 1);
  return moment(firstDay).format('YYYY-MM-DD');
};

const getMonthlyDates = (startDate, endDate) => {
  const months = {};

  let currDate = moment(startDate);
  while (currDate <= moment(endDate)) {
    const key = currDate.format('YYYY') + '-' + currDate.format('MM');

    if (months[key]) {
      months[key]['endDate'] = currDate.format('YYYY-MM-DD');
    } else {
      months[key] = {
        startDate: currDate.format('YYYY-MM-DD'),
        endDate: currDate.format('YYYY-MM-DD'),
      };
    }

    currDate = currDate.add(1, 'days');
  }

  return months;
};

const AverageAllResponse = ({ category }) => {
  const [startDate, setStartDate] = useState(getFirstDateOfMonth());
  const [endDate, setEndDate] = useState(getDaysDiff(0));
  const [monthlyDates, setMonthlyDates] = useState([]);
  const [overAllAverage, setOverAllAverage] = useState(null);
  const [officeAverage, setOfficeAverage] = useState(null);
  const [csvData, setCsvData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const getAverage = async () => {
      setIsLoading(true);
      const data = await Api.getAverageAllResponses(category, startDate, endDate, 1, startDate);
      if (data) {
        setOverAllAverage(data['avgOverall']);
        setOfficeAverage(data['avgOffice']);
        setCsvData(data['avgByTcodes']);
      }

      if (startDate && endDate) {
        const chartDates = getMonthlyDates(startDate, endDate);
        setMonthlyDates(Object.values(chartDates));
      }
      setIsLoading(false);
    };

    getAverage();
  }, [startDate, endDate]);

  return (
    <>
      <div className="well">
        <div className="row" style={{ display: 'flex', alignItems: 'center' }}>
          <div className="col-md-4">
            <h4>Hypertension Average after 60 days</h4>
            <p style={dateStyle}>
              {moment(startDate).format('MMMM D, YYYY')} - {moment(endDate).format('MMMM D, YYYY')}
            </p>
          </div>
          <div className="col-md-8">
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
              <i className="fa fa-calendar" style={{ fontSize: '20px', marginRight: '10px' }}></i>
              <div style={{ width: 180 }}>
                <DatePicker
                  dateFormat="YYYY-MM-DD"
                  value={startDate}
                  showTodayButton={true}
                  onChange={(e, formattedValue) => {
                    if (formattedValue) {
                      setStartDate(formattedValue);
                    }
                  }}
                />
              </div>
              <span style={{ margin: '0 5px' }}>—</span>
              <div style={{ width: 180 }}>
                <DatePicker
                  dateFormat="YYYY-MM-DD"
                  value={endDate}
                  showTodayButton={true}
                  onChange={(e, formattedValue) => {
                    if (formattedValue) {
                      setEndDate(formattedValue);
                    }
                  }}
                />
              </div>
              <div style={{ marginLeft: 30 }}>
                <AverageResponseCsv
                  startDate={startDate}
                  endDate={endDate}
                  csvData={csvData}
                  category={category}
                  title="Hypertension Average after 60 days"
                  overAllAvg={overAllAverage}
                  isLast={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <AverageResponseCards
        averageBio={overAllAverage?.average_bio}
        patientCount={overAllAverage?.patientCount}
        patientInControlPercent={overAllAverage?.patientInControlPercent}
        averageByOffice={officeAverage}
        isLast={false}
        isLoading={isLoading}
        category={category}
      />

      <div style={{ paddingTop: '30px', paddingBottom: '50px' }}>
        <p style={labelStyle}>Monthly Average Systolic & Diastolic</p>
        <AverageResponseChart
          category={category}
          monthlyDates={monthlyDates}
          isLast={false}
          journeyStartDate={startDate}
        />
      </div>
    </>
  );
};

export default AverageAllResponse;
